import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';


@Component({
    selector: 'app-property-select',
    template: `
<!-- <form [formGroup]="propertySelectForm">
    <mat-form-field class="flex-1">
      <mat-label>Property</mat-label>
        <mat-select placeholder="Property" formControlName="shortTermRentalId"  #str (selectionChange)="onPropertySelect(str.value)">
            <mat-option *ngFor="let order of shortTermRentals; let i = index" [value]="shortTermRentals[i].shortTermRentalId">
                 {{shortTermRentals[i].propertyCode}}
            </mat-option>
        </mat-select>
  </mat-form-field>
</form> -->

<p-autoComplete
formControlName="shortTermRentalId"
[suggestions]="shortTermRentals"
(completeMethod)="onPropertySelect($event)"
(onSelect)="onPropertySelected($event)"
[dropdown]="true"
field="propertyCode"
[forceSelection]="true"
placeholder="Search by Prop"></p-autoComplete>


`,
    standalone: false
})



export class PropertySelectComponent implements OnInit, OnChanges
{
	// forms
	propertySelectForm: UntypedFormGroup;
	formLoading = false;
	shortTermRentals = [];
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskId: number;
	@Input() shortTermRentalId: number;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService) { }
	ngOnInit()
	{
		this.propertySelectForm = this.formBuilder.group({
			shortTermRentalId: [this.shortTermRentalId],
			taskId: [this.taskId]
		});
		this.findShortTermRentals();
	}
	findShortTermRentals()
	{


		this.reportService.propertySummaryList().pipe(first()).subscribe(

			data =>
			{
				// console.log('reports are: ' + JSON.stringify(data));
				this.shortTermRentals = data.data.propertySummaryList;
				// console.log('QA: ' + JSON.stringify(this.shortTermRentals));
			},
			error =>
			{
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			console.log('Form Submitted: ' + JSON.stringify(this.propertySelectForm.value));
			if (this.propertySelectForm.invalid)
			{
				console.log('Form Invalid: ' + JSON.stringify(this.propertySelectForm.getError));
				return;
			}

			this.formLoading = true;
			this.taskService.updateShortTermRentalId(this.propertySelectForm.value)
				.subscribe(
					res =>
					{
						console.log('Property-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						// this.router.navigate(['/task-view', this.form1.value.taskId]);
					},
					err =>
					{
						console.log('Property-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
     *
     * method to update parent component
     */


	onPropertySelect(value)
	{
		console.log('Short term Fired1 ' + value);
		// This fires on typing/searching - don't emit to parent, just filter
		// The actual selection will be handled by onPropertySelected
	}

	onPropertySelected(selectedProperty: any)
	{
		console.log('Property selected: ' + JSON.stringify(selectedProperty));
		// update
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
			return;
		}
		
		// Update form with selected property
		if (selectedProperty && selectedProperty.shortTermRentalId) {
			this.propertySelectForm.patchValue({ shortTermRentalId: selectedProperty.shortTermRentalId });
			this.formUpdate();
		}

		// let the parent know in case the parent wants to do something with the value or trigger a refresh, etc.
		// Emit the full property object, not just the form value
		this.messageEvent.emit(selectedProperty);
	}

	/**
     *
     * method to update this component from parent
     */
	setShortTermRentalId(shortTermRentalId: String)
	{
		console.log('Short term Fired2 ' + shortTermRentalId);
		this.propertySelectForm.patchValue({ shortTermRentalId: shortTermRentalId });
	}

	ngOnChanges()
	{

		// if we have a property but it did not come over at initiation
		if ((this.taskId) && (this.shortTermRentalId) && this.propertySelectForm !== undefined && this.propertySelectForm.controls['shortTermRentalId'].value == null)
		{
			this.propertySelectForm.patchValue({ taskId: this.taskId, shortTermRentalId: this.shortTermRentalId });
			// 5 sec delay so there is not a race to update the same taskId record
			setTimeout(() => { this.formUpdate(); }, 5000);

		}


		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.propertySelectForm !== undefined)
		{
			this.propertySelectForm.patchValue({ taskId: this.taskId, shortTermRentalId: this.shortTermRentalId });
		}
	}
}
